import { render } from "./GlobalBackground.vue?vue&type=template&id=d1555cf8&scoped=true"
import script from "./GlobalBackground.vue?vue&type=script&lang=js"
export * from "./GlobalBackground.vue?vue&type=script&lang=js"

import "./GlobalBackground.vue?vue&type=style&index=0&id=d1555cf8&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/uparte_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1555cf8"]])

export default __exports__